import Vue from 'vue';
import Router from 'vue-router';
import payInfo from './modules/pay-info.vue';
import payResult from './modules/pay-result.vue';
import Info from './modules/common-info.vue';
import Result from './modules/common-result.vue';
import { publicPath } from './env.js';
Vue.use(Router);
var router = new Router({
  mode: 'history',
  base: "".concat(publicPath, "/mobile-pay"),
  routes: [{
    path: '/payInfo',
    name: 'payInfo',
    component: payInfo
  }, {
    path: '/payResult',
    name: 'payResult',
    component: payResult
  }, {
    path: '/info',
    name: 'info',
    component: Info
  }, {
    path: '/result',
    name: 'result',
    component: Result
  }]
});
router.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();
  window.ksLog && window.ksLog.sendPV();
});
export default router;